import { render, staticRenderFns } from "./TopBuyerCustomers.vue?vue&type=template&id=9ca17fc2&"
import script from "./TopBuyerCustomers.vue?vue&type=script&lang=js&"
export * from "./TopBuyerCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports